module.exports = __webpack_public_path__ + "img/first_down_left.17f48154.jpg";